<template>
  <div>
    <v-container fluid>

      <div class="main">

        <v-row>
          <v-col cols="12" lg="6">
            <v-tabs background-color="transparent" color="gifty">
              <v-tab to="/account-cards">
                <v-icon left size="20">mdi-account-group</v-icon>
                Liste des utilisateurs
              </v-tab>

              <v-tab to="/account-cards-templates">
                <v-icon left size="20">mdi-card-account-details</v-icon>
                Modèles de carte GIFTY
              </v-tab>
            </v-tabs>

          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="rounded-lg shadow">

              <v-overlay :value="overlay"
                         absolute
                         color="white"
                         opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      @keydown.enter="getUsers"
                      hint="Appuyez sur ↵ Entrée pour rechercher"
                      clearable
                      @click:clear="[keyword=null,getUsers()]"
                      dense
                      filled
                      persistent-hint
                      placeholder="Recherche..."
                      rounded
                  ></v-text-field>
                </div>

                <v-spacer/>

                <v-btn color="gifty"
                       text
                       class="v-btn--active"
                       @click="$refs.addCardByExcelDialog.open()">
                  <v-icon left>mdi-file-excel</v-icon>
                  Cartes par Excel
                </v-btn>

                &nbsp;

                <v-btn color="gifty"
                       text
                       class="v-btn--active"
                       @click="$refs.addCardByDBDialog.open()">
                  <v-icon left>mdi-database-plus</v-icon>
                  Cartes par BDD
                </v-btn>

                &nbsp;

                <v-btn color="gifty"
                       depressed
                       class="white--text"
                       :disabled="!account_ids.length">
                  <v-icon left>mdi-cards-outline</v-icon>
                  Cartes
                </v-btn>

                <v-btn color="grey"
                       text
                       @click="getUsers">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

                <v-btn color="grey"
                       text>
                  <v-icon left>mdi-filter-variant</v-icon>
                  Filtrer
                </v-btn>


              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading" class="pa-0">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>

                <v-card-text>

                  <v-simple-table v-if="users.length" class="table-border rounded-lg">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>
                          <v-icon @click="toggleSelectAll"
                                  color="success"
                                  v-if="allSelected">
                            mdi-checkbox-marked
                          </v-icon>

                          <v-icon @click="toggleSelectAll"
                                  v-else>
                            mdi-checkbox-blank-outline
                          </v-icon>
                        </th>
                        <th>Nom</th>
                        <th>Téléphone</th>
                        <th>Email</th>
                        <th>Solde</th>
                        <th>Date d'inscription</th>
                        <th>Cartes</th>
                        <th class="text-no-wrap">+ Carte</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(user ,index) in users" :key="index">
                        <td>

                          <v-icon @click="toggleUserSelection(user.account?.id)"
                                  color="success"
                                  v-if="isSelected(user.account?.id)">
                            mdi-checkbox-marked
                          </v-icon>

                          <v-icon @click="toggleUserSelection(user.account?.id)"
                                  v-else>
                            mdi-checkbox-blank-outline
                          </v-icon>

                        </td>
                        <td>
                          <Avatar v-if="user"
                                  :user="user"
                                  :byAccount="false"/>
                          <span v-else>-</span>
                        </td>
                        <td class="font-weight-medium text-no-wrap">{{ user.phone }}</td>
                        <td class="text-no-wrap">{{ user.email }}</td>
                        <td class="font-weight-medium gifty-text text-no-wrap">
                          <v-chip label color="gifty" dark small>
                            {{ CurrencyFormatting(user.all_balance) }}
                            Pts
                          </v-chip>
                        </td>
                        <td class="text-no-wrap">
                          {{ dateFormat(user.created_at) }}
                        </td>
                        <td>
                          <v-badge color="primary"
                                   :content="user.account?.account_cards.length"
                                   :dot="!user.account?.account_cards.length"
                                   inline>
                            <v-btn icon color="gifty"
                                   :disabled="!user.account?.account_cards.length"
                                   @click="$refs.showCardsDialog.open(user.account)">
                              <v-icon>mdi-credit-card</v-icon>
                            </v-btn>
                          </v-badge>
                        </td>
                        <td>
                          <v-btn icon color="gifty" @click="$refs.addCardDialog.open(user.account?.id)">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getUsers"/>
                  </div>

                </v-card-text>

                <v-divider v-if="total > 10"/>

                <v-card-actions v-if="total > 10">

                  <div :style="{width : '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined
                    ></v-select>
                  </div>

                  <v-spacer/>


                  <v-pagination v-if="total > 10"
                                v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="7"
                                @input="getUsers"></v-pagination>

                </v-card-actions>

              </div>

            </v-card>
          </v-col>
        </v-row>

      </div>

      <FilterDialog ref="filterDialog"
                    @filter="handleFilter"/>

      <AddCardDialog ref="addCardDialog"
                     @refresh="getUsers"
                     :templates="templates"
                     :services="services"/>

      <AddCardByDBDialog ref="addCardByDBDialog"
                         @refresh="getUsers"
                         :databases="databases"
                         :templates="templates"
                         :services="services"/>

      <AddCardByExcelDialog ref="addCardByExcelDialog"
                         @refresh="getUsers"
                         :clients="clients"
                         :databases="databases"
                         :templates="templates"
                         :services="services"/>

      <ShowCardsDialog ref="showCardsDialog"
                       @refresh="getUsers"/>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults.vue";
import FilterDialog from "./components/FilterDialog.vue";
import AddCardByDBDialog from "./components/AddCardByDBDialog.vue";
import AddCardDialog from "./components/AddCardDialog";
import AddCardByExcelDialog from "./components/AddCardByExcelDialog";
import ShowCardsDialog from "./components/ShowCardsDialog";
import Avatar from "@/components/Avatar";
import moment from "moment";

export default {
  components: {
    Avatar,
    AddCardByDBDialog,
    AddCardDialog,
    AddCardByExcelDialog,
    FilterDialog,
    ShowCardsDialog,
    NoResults,
  },
  data() {
    return {
      id: null,
      isLoading: false,
      overlay: false,
      keyword: null,

      account_ids: [],
      templates: [],
      databases: [],
      services: [],
      clients: [],

      users: [],
      perPage: 10,
      total: 0,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
    showAccount(account_id) {
      let route = this.$router.resolve({path: "/users/" + account_id})
      window.open(route.href, "_blank")
    },
    isSelected(accountId) {
      return this.account_ids.includes(accountId)
    },
    toggleUserSelection(accountId) {
      const ids = this.account_ids;
      const index = ids.indexOf(accountId);

      if (index === -1) {
        ids.push(accountId);
      } else {
        ids.splice(index, 1);
      }
    },
    toggleSelectAll() {
      const ids = this.users.map((user) => user.account?.id);
      const selectedIds = this.account_ids;

      if (this.allSelected) {
        this.account_ids = selectedIds.filter(
            (id) => !ids.includes(id)
        );
      } else {
        this.account_ids = [...new Set([...selectedIds, ...ids])];
      }
    },
    getUsers() {
      this.isLoading = true
      HTTP.get('/v1/account-cards/users?page=' + this.pagination.current, {
        params: {
          keyword: this.keyword,
          limit: this.limit,
          database_ids: this.database_ids,
        }
      }).then(res => {
        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;
        this.users = res.data.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getDatabases() {
      HTTP.get('/v1/account-cards/databases').then(res => {
        this.databases = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    getClients() {
      HTTP.get('/v1/account-cards/clients').then(res => {
        this.clients = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    getTemplates() {
      HTTP.get('/v1/account-cards/templates').then(res => {
        this.templates = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    getServices() {
      HTTP.get('/v1/fees/services').then(res => {
        this.services = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    handleFilter(e) {
      // this.dates = e.dates
      this.getUsers()
    },
  },
  created() {
    this.getUsers()
    this.getClients()
    this.getServices()
    this.getTemplates()
    this.getDatabases()

  },
  computed: {
    allSelected() {
      const selectedIds = this.account_ids;
      return this.users.every((user) => selectedIds.includes(user.account?.id));
    },
  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getUsers()
    },
  },
};
</script>

<style scoped>

</style>
